import {useEffect, useRef} from "react";
import styles from "@styles/pages/be-part-of-sidr/index.module.scss";
import * as React from "react";
import SILink from "@components/link/silink";
import {Autoplay, EffectFade, Navigation, Pagination} from "swiper";
import {Swiper, SwiperSlide} from "swiper/react";
import {EncourageBePartSidr, ImageGallery} from "../config/EncourageBePartSidr";
import {Typewriter} from 'react-simple-typewriter'
import {useInView} from "framer-motion";
import {strapi} from "@api/Strapi";

function BePartOfSidr() {

    // these variables are used to animate the left and right image when this view are on screen.
    const ref = useRef(null);
    const isInView = useInView(ref, {once: false});

    // Configuration for swiper encourage
    const swiperEncourageConfig = {
        modules: [Navigation, Pagination, EffectFade, Autoplay],
        spaceBetween: 0,
        initialSlide: 0,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index: number, className: string) {
                return `<span class="dot swiper-pagination-bullet"><div></div></span>`;
            },
        },
    }

    // Configuration for swiper gallery
    const swiperConfigGallery = {
        modules: [Navigation, Pagination, EffectFade],
        spaceBetween: 0,
        centeredSlides: false,
        centeredSlidesBounds: false,
        initialSlide: 0,
        loop: true,
        fade: "true",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 2.1,
                spaceBetween: 0,
            },
            481: {
                slidesPerView: 2,
                spaceBetween: 0,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
            1025: {
                slidesPerView: 4,
                spaceBetween: 0,
            },
            1201: {
                slidesPerView: 4,
                spaceBetween: 0,
            }
        }
    }

    /***
     * This page includes the header and footer components
     * The page contain list of data in that we have image, title, subtitle and description.
     */
    return (
        <>
            <section className={styles.banner}>
                <div className={'container'}>
                    <img src={'/assets/images/banners/be_part_of_sidr/careerpage_banner_d.webp'} alt={'find your'}/>
                    <div className={'context_box'}>
                        <div className={'find_your'}>find your</div>
                        <div className={'animated_text'}>
                            <Typewriter
                                words={['calling', 'team', 'future']}
                                loop={true}
                                typeSpeed={120}
                                deleteSpeed={90}
                                delaySpeed={1500}
                            />
                        </div>
                        <SILink classes={''} href={'/openings'}>view open positions</SILink>
                    </div>
                </div>
            </section>
            <section className={styles.life_at_sidr}>
                <img src={'/assets/images/decorations/extra/sidr_logo_golden.svg'} alt={'life at sidr'}/>
                <h1 className={'title'}>life at sidr</h1>
                <div className={'description'}>
                    We call ourselves “possibilities” for a reason: we can make happen not just what is possible,
                    but
                    what is impossible. We are collaborating on fresh ideas and new solutions in our engine room of
                    creativity, foresight, and innovation.
                    <br/><br/>
                    By becoming part of our team at SIDR, you will join other top talents in their fields. These
                    visionary minds and adventurous spirits were drawn by the chance to build and power the
                    communities
                    we serve; the fortune of new opportunity, the breaking of new ground.
                </div>
            </section>
            <section className={styles.sidr_encourage}>
                <Swiper {...swiperEncourageConfig} speed={900} slidesPerView={'auto'}>
                    {
                        EncourageBePartSidr.map((encourage, index) => {
                            return (<SwiperSlide key={'encourage-' + index} className={'container'}>
                                <div className={'image_container'}>
                                    <img src={encourage.imageUrl} alt={encourage.imageAltText}
                                         style={{height: encourage.height, width: encourage.width}}/>
                                </div>
                                <div className={'divider_line'}/>
                                <div className={'text_container'}>
                                    <p className={'title'}>{encourage.title}</p>
                                    <p className={'description'}>{encourage.description}</p>
                                </div>
                            </SwiperSlide>)
                        })
                    }
                    <div className={'swiper-pagination'}></div>
                </Swiper>
            </section>
            <section className={styles.working_in_sidr}>
                <h2 className={'title'}>working in sidr</h2>
                <p className={'description'}>
                    Because of its unprecedented scope, SIDR offers career opportunities in a wide variety of
                    fields,
                    with pursuit of excellence to create the friendly, encouraging workplace culture, enabling our
                    diverse workforce to learn and thrive.
                    <br/><br/>
                    A job at SIDR is a chance to live in the “brighter future” that we are now developing, an
                    opportunity of unprecedented scope for transformational experiences for people to live happy,
                    healthy, and fun lives.
                    As instilled in the ideals of our values, we are striving to make SIDR a place to rethink
                    innovation
                    and creativity, with leading-edge technology and a thriving business environment.

                </p>
            </section>
            <section className={styles.sidr_gallery}>
                <Swiper {...swiperConfigGallery} slidesPerView={'auto'}>
                    {
                        ImageGallery.map((honey, index) => {
                            return (<SwiperSlide key={'gallery-' + index}>
                                <div className={'image_container'}>
                                    <img loading={"lazy"} className={'image'}
                                         src={honey.imageUrl} alt={honey.imageAltText}/>
                                </div>
                            </SwiperSlide>)
                        })
                    }
                    <div className={`swiper-button-prev`} tabIndex={0}
                         role="button"
                         aria-label="Previous slide">
                        <img
                            src="/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_photo_section_left_arrow.webp"
                            alt="previous"/>
                    </div>
                    <div className={`swiper-button-next`} tabIndex={0}
                         role="button"
                         aria-label="Next slide">
                        <img
                            src="/assets/images/decorations/be_part_of_sidr/be_part_of_sidr_photo_section_right_arrow.webp"
                            alt="next"/>
                    </div>
                </Swiper>
            </section>
            <section className={styles.sidr_team} ref={ref}>
                <div className={`images ${isInView ? 'image_animation' : ''}`}>
                    <img className={'desktop'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_left.webp"
                         alt="image"/>
                    <img className={'desktop'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_right.webp"
                         alt="image"/>
                    <img className={'ipad'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_ipad_left.webp"
                         alt="image"/>
                    <img className={'ipad'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_ipad_right%20.webp"
                         alt="image"/>
                    <img className={'mobile'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_mobile_left.webp"
                         alt="image"/>
                    <img className={'mobile'}
                         src="/assets/images/decorations/be_part_of_sidr/careerpage_find_your_team_mobile_right.webp"
                         alt="image"/>
                </div>
                <div className={'container'}>
                    <div className={'content'}>
                        <span className={'find'}>find</span>
                        <span className={'your_team'}>your team</span>
                        <p className={'description'}>As we travel together, we share a vision, a better world for those
                            around us, improved
                            services, products, understanding and research.
                            <br/><br/>
                            The work the titans do at SIDR; challenging the tradition. Our strides must be great, yet
                            our footsteps light. Our destination is the journey, traveling wisely, in harmony with the
                            world. Aiming higher and reaching further. </p>
                        <SILink classes={'positions'} href={'/openings'}>view open positions</SILink>
                    </div>
                </div>
            </section>
        </>
    )
}

export async function getServerSideProps(context: any) {

    const propsList: any = {}
    propsList.seoDetails = {
        // title: `Careers | SIDR®`,
        url: context.resolvedUrl,
        // keyword: 'SIDR careers',
        // description: 'Bring your insight and imagination. Search, find and apply to careers at SIDR® and let\'s build a brighter future together.'
    };
    return {props: propsList}
}

export default BePartOfSidr;
